import { TFunction } from 'i18next';

export const Utils = {
    checkTypes: (nodeTypes: FieldType, dataType: string) => {
        if (Array.isArray(nodeTypes)) {
            if (nodeTypes?.includes(dataType)) {
                return true;
            }
            // Below code will execute if nodeType Array contains Array/Record Data type
            const filteredObj = nodeTypes.filter((item) => (typeof item === 'object' && item.type === dataType));
            if (filteredObj.length) {
                return true;
            }
        } else if (nodeTypes !== '' && typeof nodeTypes === 'object' && nodeTypes.type === dataType) {
            return true;
        } else if (nodeTypes !== '' && nodeTypes === dataType) {
            return true;
        }
        return false;
    }
};

export interface Field {
    id: string;
    name: string;
    namespace?: string;
    type: FieldType;
    fields?: Field[];
    items?: Array<string | TypeNode>;
    default?: null;
}

export type FieldType = string | TypeNode | Array<string | TypeNode>;

export interface TypeNode {
    id?: string;
    type?: FieldType;
    name?: string;
    fields?: Field[];
    items?: Array<string | TypeNode>;
}

export interface DataTypeInterface {
    dataType: string,
    id: number,
    text: string
}

export type TranslateHook = TFunction<'translation', undefined, 'translation'>
